var React = require('react');

function MaskMenu (props) {
    return React.createElement("svg",props,React.createElement("defs",null,React.createElement("clipPath",{"clipPathUnits":"userSpaceOnUse","id":"menuClipPath"},React.createElement("path",{"d":"M279.763 0l.049 666.451H5.371s5.084-68.292 3.984-190.214c-.746-83.017-5-176.226-4.181-252.814.972-91.274 9.006-154.724.496-166.161-7.473-36.475-4.13-36.9-.496-56.779C96.704.644 188.234.284 279.763 0z"}))));
}

MaskMenu.defaultProps = {"viewBox":"0 0 279.813 666.452","width":"279.813","height":"666.452"};

module.exports = MaskMenu;

MaskMenu.default = MaskMenu;
